import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { logout } = useAuth();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const isActive = (path) => {
    return location.pathname === path;
  };

const navLinks = [
    { path: '/dashboard', label: 'Dashboard', icon: '📊' },
    { path: '/devices', label: 'Devices', icon: '💻' },
    { path: '/threat-detection', label: 'Threat Detection', icon: '🛡️' },
    { path: '/threat-intelligence', label: 'Threat Intelligence', icon: '🔍' },
    { path: '/cloud-security', label: 'Cloud Security', icon: '☁️' },
    { path: '/access-control', label: 'Access Control', icon: '🔐' },
    { path: '/reports', label: 'Reports', icon: '📄' },
    { path: '/audit-logs', label: 'Audit Logs', icon: '📋' },
    { path: '/team', label: 'Team', icon: '👥' },
    { path: '/settings', label: 'Settings', icon: '⚙️' },
  ];

  return (
    <nav className="bg-cyber-card border-b border-gray-800">
      {/* Top Row - Branding & Logout */}
      <div className="border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-12">
            <Link to="/dashboard" className="text-lg font-bold text-cyber-cyan">
              CyberGuard HQ - Powered by Aslan Defense
            </Link>
            <button
              onClick={handleLogout}
              className="px-4 py-2 text-sm font-medium text-gray-300 hover:text-white hover:bg-cyber-darker rounded-lg transition-colors"
            >
              Logout
            </button>
          </div>
        </div>
      </div>

      {/* Bottom Row - Navigation Links */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-center items-center h-12">
          <div className="flex space-x-1">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`inline-flex items-center px-3 py-2 text-xs font-medium rounded-lg transition-colors whitespace-nowrap ${
                  isActive(link.path)
                    ? 'bg-cyber-cyan text-cyber-darker'
                    : 'text-gray-300 hover:bg-cyber-darker hover:text-white'
                }`}
              >
                <span className="mr-1.5">{link.icon}</span>
                {link.label}
              </Link>
            ))}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;